import type { Locale } from "antd/es/locale"
import enUS from "antd/locale/en_US"
import esES from "antd/locale/es_ES"
import frFR from "antd/locale/fr_FR"
import idID from "antd/locale/id_ID"
import ptPT from "antd/locale/pt_PT"
import ruRU from "antd/locale/ru_RU"
import thTH from "antd/locale/th_TH"
import viVN from "antd/locale/vi_VN"

// 支持的语言类型
export type SupportedLocale = "en" | "es" | "fr" | "id" | "pt" | "th" | "ru" | "vn"

// Ant Design locale 映射
const antdLocaleMap: Record<SupportedLocale, Locale> = {
  en: enUS,
  es: esES,
  fr: frFR,
  id: idID,
  pt: ptPT,
  th: thTH,
  ru: ruRU,
  vn: viVN,
}

/**
 * 根据 next-intl 的语言代码获取对应的 Ant Design locale
 * @param locale - next-intl 的语言代码
 * @returns 对应的 Ant Design locale 对象
 */
export function getAntdLocale(locale: string): Locale {
  // 如果语言代码在支持列表中，返回对应的 locale
  if (locale in antdLocaleMap) {
    return antdLocaleMap[locale as SupportedLocale]
  }

  // 如果语言代码不在支持列表中，尝试匹配主要语言部分
  const mainLang = locale.split("-")[0] as SupportedLocale
  if (mainLang in antdLocaleMap) {
    return antdLocaleMap[mainLang]
  }

  // 默认返回英文
  return enUS
}

/**
 * 获取所有支持的语言列表
 * @returns 支持的语言代码数组
 */
export function getSupportedLocales(): SupportedLocale[] {
  return Object.keys(antdLocaleMap) as SupportedLocale[]
}

/**
 * 检查语言是否被支持
 * @param locale - 要检查的语言代码
 * @returns 是否支持该语言
 */
export function isLocaleSupported(locale: string): boolean {
  return locale in antdLocaleMap || (locale?.split("-")[0] as SupportedLocale) in antdLocaleMap
}
